export { MacBookWindow } from './MacBookWindow.component';
export { resolveButtonShadow, resolveGradient } from './MacBookWindow.utils';
